import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { apiUrl, toFormData } from 'src/app/shared/utils';
import { NgAddToCalendarService, ICalendarEvent } from '@trademe/ng-add-to-calendar';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format
} from 'date-fns';

import { map } from "rxjs/operators";

import { HttpClient, HttpParams } from "@angular/common/http";

import { Subject, Observable } from 'rxjs';
declare var jQuery: any;
declare var $: any;
import * as moment from 'moment'



import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarDateFormatter,
  CalendarView,
} from 'angular-calendar';
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};
interface Film {
  id: number;
  release_date: string;
  location: string;
  date_time: string;
}

function getTimezoneOffsetString(date: Date): string {
  const timezoneOffset = date.getTimezoneOffset();
  const hoursOffset = String(
    Math.floor(Math.abs(timezoneOffset / 60))
  ).padStart(2, "0");
  const minutesOffset = String(Math.abs(timezoneOffset % 60)).padEnd(2, "0");
  const direction = timezoneOffset > 0 ? "-" : "+";

  return `T00:00:00${direction}${hoursOffset}:${minutesOffset}`;
}

@Component({
  selector: 'app-fixtures',
  templateUrl: './fixtures.component.html',
  styleUrls: ['./fixtures.component.scss'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})
export class FixturesComponent implements OnInit {

  seasonList: any = "";
  main_tabid = 1;
	livestatus: any = "Live";
  livematcheList: any = "";
  liverequest: any = {
		series_type_id: this.main_tabid,
		matche_status: this.livestatus
	};
  seasontypeList: any = "";
  matchesList: any = "";
  matchesnewList: any = "";
  
  seasontype: any = 0;
  seasontypeid: any = 8;
  membershipList: any = "";
  status: any = "Upcoming";
  matchesrequest: any = {
    series_type_id: this.main_tabid,
    matche_status: this.status
  };
  matchesallrequest: any = {
    season_type_id: this.seasontypeid
  };
  matchesrequestnew: any = {
    series_type_id: this.main_tabid,
    matche_status: this.status,
    
  };
  contentRequest: any = {};
	contentList: any = {};

  dateList: any = [];
  next_btn: boolean = true;
  matchvalue: any = 0;
  total: any = 0;
  first_name: any;
  first_image: any;
  date_time: any;
  second_name: any;
  second_image: any;
  startdate: any = [];
  livematchesList: any = "";
  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  events$: Observable<CalendarEvent<{ film: Film }>[]>;

  activeDayIsOpen: boolean = false;

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  public googleCalendarEventUrl: SafeUrl;
  public newEvent: ICalendarEvent;

  constructor(private allpagesService: AllPageService,
    private http: HttpClient,
    private _addToCalendarService: NgAddToCalendarService,
    private _sanitizer: DomSanitizer) { 
      this.newEvent = {
        // Event title
        title: 'My event title',
        // Event start date
        start: new Date('June 15, 2013 19:00'),
        // Event duration (IN MINUTES)
        duration: 120,
        // If an end time is set, this will take precedence over duration (optional)
        end: new Date('June 15, 2013 23:00'),
        // Event Address (optional)
        address: '1 test street, testland',
        // Event Description (optional)
        description: 'An awesome event'
    };
    this.googleCalendarEventUrl = this._sanitizer.bypassSecurityTrustUrl(
      this._addToCalendarService.getHrefFor(this._addToCalendarService.calendarType.google, this.newEvent)
  );
    }

  slidematchbookConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 2,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  slidematchreportConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 2,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  ngOnInit() {

    this.loadBannerbottom();
    this.fetchEvents();
    setTimeout(() => {
      //console.log(this.events$);
    }, 5000);
    this.loadmatches();
    this.loadmatchesnew(); 
    this.loadmatcheslive();

    this.allpagesService.getSeasontype().then((data) => {
      this.seasonList = data;
      this.seasontypeList = data.data[this.seasontype];
      //console.log(this.seasonList);
      setTimeout(() => {

        jQuery('.select_tab').on('change', (e) => {
          var dataseason = e.currentTarget.value;
          this.seasontypeid = dataseason;
          this.seasontype = dataseason - 1;
          //console.warn(dataseason);
          //console.log(this.seasontype);
          this.seasontypeList = data.data[this.seasontype];
          //console.warn(this.seasontypeList);
          this.matchesallrequest = {
            season_type_id: this.seasontypeid
          };
          this.loadmatchesnew();
        });
        jQuery('ul.maintab li a').click((e) => {
          var dataid = e.currentTarget.id;
          this.main_tabid = dataid;
          this.matchesrequest = {
            series_type_id: this.main_tabid,
            matche_status: this.status
          };
          this.matchesrequestnew = {
            series_type_id: this.main_tabid,
            matche_status: this.status,
            
          };
          this.loadmatches();
          this.fetchEvents();
        });

        jQuery('ul.subtab li a').click((e) => {
          var datastatus = e.currentTarget.id;
          this.status = datastatus;
          this.matchesrequest = {
            series_type_id: this.main_tabid,
            matche_status: this.status
          };
          this.matchesrequestnew = {
            series_type_id: this.main_tabid,
            matche_status: this.status,
            
          };
          this.loadmatches();
          this.fetchEvents();
        });

      }, 1000);


    });

    this.allpagesService.getMembership().then((data) => {
      this.membershipList = data;
      //console.log(this.membershipList);
    });
  }

  loadmatcheslive() {
		let request = Object.assign({}, this.liverequest);
		this.allpagesService.getMatcheslist(request).then((data: any) => {
			this.livematcheList = data;
			this.livematchesList = data.data[0];

			//console.warn(this.livematchesList);
		});
	}

  loadBannerbottom() {
		this.contentRequest = {
			title: 'Fixtures'
		};
		let request = Object.assign({}, this.contentRequest);
		this.allpagesService.getContactText(request).then((data: any) => {
			this.contentList = data.data[0];
			//console.log(this.bannerList);
		});
	}

  

  fetchEvents(): void {
    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];

    const params = new HttpParams()
      .set(
        "primary_release_date.gte",
        format(getStart(this.viewDate), "yyyy-MM-dd")
      )
      .set(
        "primary_release_date.lte",
        format(getEnd(this.viewDate), "yyyy-MM-dd")
      )
      .set("api_key", "0ec33936a68018857d727958dca1424f");
    let request = Object.assign({}, this.matchesrequestnew);
    this.events$ = this.http
      .post("https://www.leicestershireccc.co.uk/Lccc/api/beforeauth/getmatcheslist", toFormData(request))
      .pipe(
        map(({ data }: { data: Film[] }) => {
          return data.map((film: Film) => {
            return {
              title: film.location,

              start: new Date(
                moment(film.date_time).format('YYYY-MM-DD') + getTimezoneOffsetString(this.viewDate)
              ),

              //color: colors.yellow,
              allDay: true,
              meta: {
                film
              }
            };
          });
        })
      );


  }

  loadmatches(): void {
    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];

    const params = new HttpParams()

    //console.log(this.main_tabid);
    //console.log(this.status);
    let request = Object.assign({}, this.matchesrequest);
    this.allpagesService.getMatcheslist(request).then((data: any) => {
      this.matchesList = data;

      //console.log(this.matchesList);
    });
  }

  loadmatchesnew(){

    let request = Object.assign({}, this.matchesallrequest);
    this.allpagesService.getMatcheslistnew(request).then((data: any) => {
      this.matchesnewList = data;
      setTimeout(() => {
        jQuery(".courses-name").click(function () {
          if (jQuery(this).hasClass('active')) {
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".courses-name").removeClass('active');
            jQuery(this).addClass('active');
            jQuery(".course-main-content").removeClass('active');
            jQuery("#" + tabid + "-content").addClass("active");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail .inner-name:first").addClass("active");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-inner-detail-content.inner-main-content:first").addClass("active");
          }
          return false;
        });

        jQuery(".inner-name").click(function () {
          if (jQuery(this).hasClass('active')) {
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".inner-name").removeClass('active');
            jQuery(this).addClass('active');
            jQuery(".inner-main-content").removeClass('active');
            jQuery("#" + tabid + "-content").addClass("active");
            jQuery("#" + tabid + "-content").addClass("active");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-name:first").addClass("ok");
            jQuery("#" + tabid + "-content").find(".fixture-season-tab-matches .fixtures-main-content:first").addClass("ok");
          }
          return false;
        });

        jQuery(".fixtures-name").click(function () {
          if (jQuery(this).hasClass('ok')) {
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".fixtures-name").removeClass('ok');
            jQuery(this).addClass('ok');
            jQuery(".fixtures-main-content").removeClass('ok');
            jQuery("#" + tabid + "-content").addClass("ok");
          }
          return false;
        });

      }, 1000);

      //console.warn(this.matchesnewList);
    });

  }
  dayClicked({
    date,
    events
  }: {
    date: Date;
    events: CalendarEvent<{ film: Film }>[];
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  eventClicked(event: CalendarEvent<{ film: Film }>): void {
    window.open(
      `https://www.themoviedb.org/movie/${event.meta.film.id}`,
      "_blank"
    );
  }

}
